import { useAppRouter } from '@/common/route/useAppRouter';
import { StringUtils } from '@/common/utils/stringUtils';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_CHAT } from '@/modules/chat/router';
import { chatService } from '@/services/chat';
import useVuelidate from '@vuelidate/core';
import { integer, required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useMixins() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const model = reactive({
        id: StringUtils.toNumber(route.params.id),
        name: '',
        position: null,
        canDelete: false
    });

    const validations = {
        name: { required },
        position: { required, integer }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        canExecute: () => model.id != null,
        request: () => chatService.sentence.get(model.id),
        onSuccess: ({ data }) => {
            model.id = data.id;
            model.name = data.name;
            model.position = data.position;
            model.canDelete = data.canDelete;
        },
        onError: () => router.push({ name: ROUTE_NAME_CHAT.SENTENCE.INDEX })
    });

    const actions = {
        create: crudAction.excuteAndNotify({
            validator: v$,
            request: () => chatService.sentence.create(model.name, model.position),
            onSuccess: () => router.push({ name: ROUTE_NAME_CHAT.SENTENCE.INDEX })
        }),
        update: crudAction.excuteAndNotify({
            validator: v$,
            request: () => chatService.sentence.update(model.id, model.name, model.position),
            onSuccess: () => router.push({ name: ROUTE_NAME_CHAT.SENTENCE.INDEX })
        })
    };

    return { model, v$, fetch, actions };
}
